import { anatomyConstants } from "../../constants/anatomyConstants";

const VideoSnackbar = ({ status, seconds }) => {
  if (!status) return null;

  const maxSeconds = 30;
  const progressPercent = (seconds / maxSeconds) * 100;

  let message = "";
  let bgClass = "bg-gray-800";
  let styleVars = {};

  switch (status) {
    case "recording":
      message = `Recording: ${seconds}s / ${maxSeconds}s`;
      bgClass = "bg-[var(--main-color)]";
      styleVars = { "--main-color": anatomyConstants.mainColor };
      break;
    case "success":
      message = "Video saved successfully!";
      bgClass = "bg-green-500";
      break;
    case "error":
      message = "Video recording failed!";
      bgClass = "bg-red-500";
      break;
    default:
      message = "";
      bgClass = "bg-gray-800";
  }

  return (
    <div
      className={`
        fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50
        px-6 py-3 rounded-lg shadow-xl text-white font-semibold text-sm
        transition-all duration-300
        ${bgClass}
      `}
      style={{ minWidth: 220, textAlign: "center", ...styleVars }}
    >
      {message}
      {status === "recording" && (
        <div className="w-full h-1 bg-white/30 rounded-full mt-2 overflow-hidden">
          <div
            className="h-full bg-white transition-all duration-100"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default VideoSnackbar;
